var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, } from "react";
import { useLoaderButton, Captcha, InputGroup, InputLabel, InputText, useCaptcha, useNotificationsCtx, TNotificationType, } from "@gw/component-library";
import { useEnvContext } from "@gw/env-context";
import { useBNIdentity } from "@gw/bn-identity";
var ForgotPwd = function () {
    var requestPwdResetCode = useBNIdentity().requestPwdResetCode;
    var reCaptchaSiteKey = useEnvContext().reCaptchaSiteKey;
    var _a = useCaptcha(), captchaToken = _a.captchaToken, onCaptchaChange = _a.onCaptchaChange, captchaError = _a.captchaError, setCaptchaError = _a.setCaptchaError, captchaRef = _a.captchaRef, resetCaptcha = _a.resetCaptcha;
    var _b = useState(""), email = _b[0], setEmail = _b[1];
    var _c = useState({}), errors = _c[0], setErrors = _c[1];
    var addNotification = useNotificationsCtx().addNotification;
    var _d = useLoaderButton({}), LoaderButton = _d.LoaderButton, enableButton = _d.enableButton, disableButton = _d.disableButton, setLoadingButton = _d.setLoadingButton;
    var canProceed = email !== "" && captchaToken !== null;
    useEffect(function () {
        if (!canProceed) {
            disableButton();
        }
        else {
            enableButton();
        }
    }, [email, captchaToken]);
    var handleSubmit = function (ev) {
        ev.preventDefault();
        setLoadingButton();
        requestPwdResetCode(email, captchaToken)
            .then(function () {
            addNotification("Password reset requested! Please check your email for instructions...", TNotificationType.success);
            setEmail("");
            resetCaptcha();
            disableButton();
        })
            .catch(function (error) {
            resetCaptcha();
            var email = error.email, recaptcha_token = error.recaptcha_token, message = error.message;
            if (email) {
                setErrors(Object.assign(__assign({}, errors), { email: email }));
            }
            if (recaptcha_token) {
                setCaptchaError(recaptcha_token);
            }
            if (message) {
                setErrors({});
            }
            addNotification(email || recaptcha_token
                ? "Please review the errors below."
                : "We could not find a user with that email.", TNotificationType.error);
            disableButton();
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { className: "auth-form", onSubmit: handleSubmit },
            React.createElement(InputGroup, null,
                React.createElement(InputLabel, null, "Email:"),
                React.createElement(InputText, { placeholder: "email@domain.com", type: "email", value: email, onChange: function (ev) {
                        return setEmail(ev.target.value);
                    } }),
                errors.email && React.createElement("span", { className: "error-msg" }, errors.email)),
            React.createElement("p", { className: "instructions" }, "After submitting this form you will get an email with instructions on how to reset your password."),
            React.createElement("div", { className: "actions" },
                React.createElement(Captcha, { ref: captchaRef, captchaError: captchaError, reCaptchaSiteKey: reCaptchaSiteKey, onCaptchaChange: onCaptchaChange }),
                React.createElement("div", { className: "btn-container" },
                    React.createElement(LoaderButton, null,
                        React.createElement(React.Fragment, null, "Request Instructions")))))));
};
export default ForgotPwd;
//# sourceMappingURL=ForgotPwd.js.map